import React from 'react';
import {
    Badge,
    Box,
    Flex,
    List,
    ListItem,
    Text,
} from '@chakra-ui/react';

import data from '../../data/asignaturas.json';

const CREDITOS_TOTALES = 240;
const CREDITOS_RECONOCIDOS = 48;
const CREDITOS_MATRICULADOS = 36;

export function Ingenieria() {

    const pctReconocidos = (CREDITOS_RECONOCIDOS / CREDITOS_TOTALES) * 100;
    const pctMatriculados = (CREDITOS_MATRICULADOS / CREDITOS_TOTALES) * 100;

    return (
        <>
        
            <Text
                fontSize="2xl"
                fontWeight="bold"
                color="white"
                mb={2}
            >
                {data.titulo}
            </Text>

            <Flex
                w="80%"
                h="10px"
                borderRadius="full"
                overflow="hidden"
                bg="gray.700"
                mb={3}
            >
                <Box
                    w={`${pctReconocidos}%`}
                    bg="green.400"
                />
                <Box
                    w={`${pctMatriculados}%`}
                    bg="blue.600"
                />
                {/* <Box
                    w={`${data.progreso}%`}
                    bg="green.400"
                /> */}
            </Flex>

            <Flex gap={4} mb={5} wrap="wrap">
                <Flex align="center" gap={2}>
                    <Box w="10px" h="10px" borderRadius="full" bg="green.600" />
                    <Text fontSize="sm" color="gray.400">
                        Reconocido Grado Superior ASIR ({CREDITOS_RECONOCIDOS} créditos)
                    </Text>
                </Flex>
                <Flex align="center" gap={2}>
                    <Box w="10px" h="10px" borderRadius="full" bg="blue.600" />
                    <Text fontSize="sm" color="gray.400">
                        Matriculado actualmente ({CREDITOS_MATRICULADOS} créditos)
                    </Text>
                </Flex>
                {/* <Flex align="center" gap={2}>
                    <Box w="10px" h="10px" borderRadius="full" bg="green.400" />
                    <Text fontSize="sm" color="gray.300">
                        Aprobados
                    </Text>
                </Flex> */}
            </Flex>

            <List>
                {data.asignaturas.map((asig, index) => (
                    <ListItem key={index} mb={2}>
                        <Badge mr={2}>{asig.estado}</Badge>
                        <Badge mr={2} bg={asig.colorFondo}>
                            Cuatrimestre {asig.cuatrimestre}
                        </Badge>
                        <Badge mr={2}>{asig.tipo}</Badge>
                        <Badge mr={2}>{asig.creditos}</Badge>
                        <Badge mr={2}>{asig.codigo}</Badge>
                        {asig.nombre}
                    </ListItem>
                ))}
            </List>

            <Box mb={5} />
        
        </>
    );
}